import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../../services/authService";
import { removeBg } from "../../services/removeBg";
export const removeBgAction = createAsyncThunk(
  "removeBg/removeBg",
  async ({ user_id, image_path, image_extension }, thunkAPI) => {
    try {
      const data = await removeBg(user_id, image_path, image_extension);
      return { response: data.data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
const initialState = {
  response: null,
  backgroundImage: "",
  cropedImage: "",
};
const removeBgSlice = createSlice({
  name: "removeBg",
  initialState,
  extraReducers: {
    [removeBgAction.fulfilled]: (state, action) => {
      state.response = action.payload.response;
      state.backgroundImage = action.payload.response.remove_bg_image;
      state.cropedImage = action.payload.response.crop_image;
    },
    [removeBgAction.rejected]: (state, action) => {
      state.response = null;
      state.message = action.payload;
    },
    clearImage: (state) => {
      state.response = null;
      state.backgroundImage = "";
    },
  },
});
const { reducer } = removeBgSlice;
export default reducer;
